import { app } from "@/config/env";
import { sendAnalyticData } from "@/lib/monitoring/analytics";

import { Redirect, useParams } from "@luce/core/adapters/navigation";
import { GiftDetail } from "@luce/customer-app";

export function GiftDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Redirect to="/profile/gift-card" replace />;
  }

  // TODO: refactor the usage of app env LUCE_WEB_DOMAIN and tracking helper after core lib migrated
  return <GiftDetail giftCardId={id} webDomain={app.LUCE_WEB_DOMAIN} onTrack={sendAnalyticData} />;
}

/**
 * Legacy URLs for card status pages now redirect to the unified detail page.
 * Kept for existing shared links; remove once no references remain.
 */
export function LegacyGiftDetailRedirect() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Redirect to="/profile/gift-card" replace />;
  }

  return <Redirect to={`/profile/gift-card/${id}`} replace />;
}
